const { COMMERCE_HEADER } = require('../constants');
const { getChannelId, getEcommId, getXCommerceValue } = require('../lib/browserData');
const http = require('../lib/httpClient');

const endpoint = '/v1/validate';
const service = '/s/auth';
// eslint-disable-next-line default-param-last
async function catalystAuthValidate(
  // eslint-disable-next-line default-param-last
  catalystBaseUrl = '',
  sessionId,
  tenantId,
  channel,
  additionalInfo,
) {
  const result = await http.post(
    `${catalystBaseUrl || service}${endpoint}`,
    { sessionId },
    {
      headers: {
        'x-channel-id': getChannelId(channel),
        'x-ecomm-name': getEcommId(tenantId, additionalInfo),
        'x-commerce': getXCommerceValue(catalystBaseUrl) || COMMERCE_HEADER,
      },
    },
  );

  const { responseBody } = result || {};

  if (!responseBody) {
    return { active: false };
  }
  return responseBody;
}

module.exports = catalystAuthValidate;
